export const Crop = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 2V23C8 23.5523 8.44772 24 9 24H30" stroke="currentColor" stroke-width="2"/>
<path d="M24 20V9C24 8.44772 23.5523 8 23 8H12" stroke="currentColor" stroke-width="2"/>
<path d="M2 8H8" stroke="currentColor" stroke-width="2"/>
<path d="M24 30V24" stroke="currentColor" stroke-width="2"/>
</svg>`;
